import { z } from 'zod';
const trimmedNonEmptyString = (fieldName) => z
    .string({ message: `${fieldName} is required` })
    .trim()
    .min(1, `${fieldName} is required`);
const optionalTrimmedNonEmptyString = (fieldName) => z.string().trim().min(1, `${fieldName} must be a non-empty string when provided`).optional();
export const RepsolIssueLoginUrlRequestSchema = z.object({
    repsolUserId: trimmedNonEmptyString('repsolUserId'),
    repsolBusinessId: trimmedNonEmptyString('repsolBusinessId'),
    businessName: optionalTrimmedNonEmptyString('businessName'),
    userName: optionalTrimmedNonEmptyString('userName'),
    userEmail: z
        .string()
        .trim()
        // we use the pipe in order to be able to trim the field
        .pipe(z.email({ error: 'userEmail must be a valid email address when provided' }))
        .optional(),
    phoneNumber: optionalTrimmedNonEmptyString('phoneNumber'),
    spaces: z.array(trimmedNonEmptyString('spaces')).optional(),
});
export const RepsolIssueLoginUrlResponseSchema = z.object({
    redirectUrl: z.string().min(1),
});
//# sourceMappingURL=RepsolIssueLoginUrlSchema.js.map